export const SHOPPING_LIST_NUM = 'SHOPPING_LIST_NUM' // 购物车数量
export const ADDRESS_INFO = 'ADDRESS_INFO' // 订单结算点击地址列表
export const TAKER_INFO = 'TAKER_INFO' // 订单结算点击提货人列表
export const ORDER_CUOPON = 'ORDER_CUOPON' // 订单结算优惠券
export const INVOICE_TITLE = 'INVOICE_TITLE' // 申请发票发票抬头



// WEBPACK FOOTER //
// ./src/stores/mall/types.js